/* eslint-disable no-console */
import { getBackendURL } from 'store/interceptors';
import { TrackerEvent, TrackerProvider } from '../../components/Tracker/TrackerProvider';
import { flattenComplexObject } from './flattenComplexObject';

const auditTrackerProvider = (): TrackerProvider<Partial<TrackerEvent>, Partial<TrackerEvent>> => ({
  assertShouldTrack: (event: Partial<TrackerEvent>) =>
    [
      'difference-all-restored', // this feels irrelevant and has not been used given the functionality of the button
      'difference-discarded', // this feels irrelevant and has not been used given the functionality of the button
      'difference-restored', // this feels irrelevant and has not been used given the functionality of the button
      'differences-merged',
      'document-inspected',
      'file-downloaded',
      'report-downloaded',
      'user-login-attempted',
      'user-login-sso-success-client',
      'user-login-non-sso-success-client',
      'user-logout-client',
      'user-login-attempt-failed',
      'markup-created',
      'markup-linked',
      'source-anchor-placed',
      'source-anchor-deleted',
      'new-anchor-placed',
      'new-anchor-deleted',
      'bulk-action-comment-added',
      'bulk-action-false-positive-reported',
      'bulk-action-status-selected',
      'bulk-action-mark-unassigned-clicked',
    ].includes(event.name as string),
  parse: ({
    data,
    inspectionId,
    tenantId,
    orgId,
    userEmail,
    ...metadata
  }: Partial<TrackerEvent> & { data: Record<any, any>; userEmail: string }) => ({
    ...metadata,
    data: flattenComplexObject(data, ''),
    inspectionId: inspectionId !== '' ? inspectionId : undefined,
    sentAt: new Date().toISOString(),
    tenantId,
    orgId,
  }),
  track: async (event: Partial<TrackerEvent>) => {
    const url = getBackendURL('audit/events');

    await fetch(url, {
      headers: {
        'content-type': 'application/json',
      },
      method: 'PUT',
      body: JSON.stringify(event),
    }).catch((error) => console.error(error));
  },
});

export default auditTrackerProvider;
